import { Typography } from '@mui/material';
import React from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';
import config from 'config';

import { Layout } from './Components/Layout';

export const Rest = ({ send }: StepComponentProps) => (
  <Layout title="None of the above" send={send}>
    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      None of the above?
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      If you couldn’t find yourself in the search and if none of these options apply to you please
      reach out to{' '}
      <a
        href={`mailto:${config.nonprofitSuccessTeamEmail}`}
        style={{ textDecoration: 'underline' }}
      >
        {config.nonprofitSuccessTeamEmail}
      </a>{' '}
      to get a support
    </Typography>
  </Layout>
);
